<div class="example-container">
    <div class="table-wrapper">
        <table mat-table [dataSource]="dataSource">
            <!-- Start Date Column -->
            <ng-container matColumnDef="startDate">
                <th mat-header-cell *matHeaderCellDef width="150">Start Date</th>
                <td mat-cell *matCellDef="let event">{{ event.startDate | date: 'short' }}</td>
            </ng-container>

            <!-- End Date Column -->
            <ng-container matColumnDef="endDate">
                <th mat-header-cell *matHeaderCellDef width="150">End Date</th>
                <td mat-cell *matCellDef="let event">{{ event.endDate | date: 'short' }}</td>
            </ng-container>

            <!-- Location Column -->
            <ng-container matColumnDef="location">
                <th mat-header-cell *matHeaderCellDef>Location</th>
                <td mat-cell *matCellDef="let event">
                    {{ event.location }}
                </td>
            </ng-container>

            <!-- Subtitle Column -->
            <ng-container matColumnDef="subtitle">
                <th mat-header-cell *matHeaderCellDef>Subtitle</th>
                <td mat-cell *matCellDef="let event">
                    {{ event.subtitle }}
                </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let event">
                    <button mat-flat-button color="primary" (click)="editEventDetail(event)">Edit</button>
                    <button mat-flat-button color="warn" (click)="deleteEventDetail(event)">Delete</button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No dates listed for this event.</td>
            </tr>
        </table>
    </div>

    <div style="margin-top: 20px; margin-bottom: 10px">
        <button mat-flat-button color="ascent" (click)="addEventDetail()">Add</button>
    </div>
</div>
